import riot from 'riot';
import events from '../src/events.js';
riot.tag2('user-dashboard', '<div class="container is-fluid" style="margin-top: 5px; background: white; padding: 20px;"> <div class="columns"> <div class="column"> <h1 class="title is-3"> <span class="icon-text"> <span class="icon has-text-info"> <i class="fas fa-chart-line"></i> </span> <span>My Dashboard</span> </span> </h1> <p class="subtitle is-6">Summary of your learning activities on the platform</p> </div> </div> <div class="columns is-multiline"> <div class="column is-3"> <div class="box has-background-info-light"> <div class="level"> <div class="level-item has-text-centered"> <div> <p class="heading">Active Activities</p> <p class="title">{activeCount}</p> </div> </div> </div> </div> </div> <div class="column is-3"> <div class="box has-background-success-light"> <div class="level"> <div class="level-item has-text-centered"> <div> <p class="heading">Completed Activities</p> <p class="title">{completedCount}</p> </div> </div> </div> </div> </div> <div class="column is-3"> <div class="box has-background-warning-light"> <div class="level"> <div class="level-item has-text-centered"> <div> <p class="heading">Total Lessons</p> <p class="title">{uniqueLessonsCount}</p> </div> </div> </div> </div> </div> <div class="column is-3"> <div class="box has-background-primary-light"> <div class="level"> <div class="level-item has-text-centered"> <div> <p class="heading">Connected Kits</p> <p class="title">{totalKitsCount}</p> </div> </div> </div> </div> </div> </div> <div class="columns"> <div class="column"> <div class="box"> <h2 class="title is-4"> <span class="icon-text"> <span class="icon has-text-success"> <i class="fas fa-check-circle"></i> </span> <span>Completed Activities</span> </span> </h2> <div if="{completedActivities.length === 0}" class="notification is-light"> No completed activities yet. Keep learning! </div> <div if="{completedActivities.length > 0}"> <table class="table is-striped is-hoverable is-fullwidth"> <thead> <tr> <th>Lesson</th> <th>Type</th> <th>Reference</th> <th>Kits Used</th> <th>Action</th> </tr> </thead> <tbody> <tr each="{a in completedActivities}"> <td> <div class="is-flex is-align-items-center" if="{a.lesson}"> <figure class="image is-32x32" style="margin-right: 10px;"> <img riot-src="img/{a.lesson.icon}" alt="{a.lesson.name}"> </figure> <span><strong>{a.lesson.name}</strong></span> </div> <div if="{!a.lesson}"> <span class="has-text-grey-light"><em>Legacy Activity</em></span> </div> </td> <td> <span class="tag is-info" if="{a.lesson}">{a.lesson.type || \'lesson\'}</span> <span class="tag is-light" if="{!a.lesson}">unknown</span> </td> <td> <code>{a.activity_ref}</code> </td> <td> <span class="tags" if="{a.device_ids && a.device_ids.length > 0}"> <span class="tag" each="{kit in a.device_ids}">{kit}</span> </span> <span if="{!a.device_ids || a.device_ids.length === 0}" class="has-text-grey-light">None</span> </td> <td> <div class="buttons"> <button class="button is-small is-info" if="{a.lesson}" onclick="{viewActivityDashboard}"> <span class="icon is-small"> <i class="fas fa-chart-pie"></i> </span> <span>View Stats</span> </button> <button class="button is-small is-success" if="{a.lesson}" onclick="{startDuplicateActivity}"> <span class="icon is-small"> <i class="fas fa-copy"></i> </span> <span>Start Again</span> </button> <span if="{!a.lesson}" class="has-text-grey-light"><em>No actions available</em></span> </div> </td> </tr> </tbody> </table> </div> </div> </div> </div> <div class="columns" if="{lessonGroups && lessonGroups.length > 0}"> <div class="column"> <div class="box"> <h2 class="title is-4"> <span class="icon-text"> <span class="icon has-text-primary"> <i class="fas fa-book"></i> </span> <span>Activities by Lesson</span> </span> </h2> <div class="columns is-multiline"> <div class="column is-4" each="{group in lessonGroups}"> <div class="card"> <div class="card-content"> <div class="media"> <div class="media-left"> <figure class="image is-48x48"> <img riot-src="img/{group.lesson.icon}" alt="{group.lesson.name}"> </figure> </div> <div class="media-content"> <p class="title is-5">{group.lesson.name}</p> <p class="subtitle is-6">{group.activities.length} {group.activities.length === 1 ? \'activity\' : \'activities\'}</p> </div> </div> <div class="content"> <div class="tags"> <span class="tag is-success is-light" if="{group.completedCount > 0}"> {group.completedCount} completed </span> <span class="tag is-info is-light" if="{group.activeCount > 0}"> {group.activeCount} active </span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div>', 'user-dashboard .box,[data-is="user-dashboard"] .box{ box-shadow: 0 2px 8px rgba(0,0,0,0.1); } user-dashboard .table td,[data-is="user-dashboard"] .table td{ vertical-align: middle; } user-dashboard .icon-text,[data-is="user-dashboard"] .icon-text{ display: inline-flex; align-items: center; gap: 0.5rem; }', '', function(opts) {

        var self = this;

        self.activeCount = 0;
        self.completedCount = 0;
        self.uniqueLessonsCount = 0;
        self.totalKitsCount = 0;
        self.completedActivities = [];
        self.lessonGroups = [];

        self.calculateStats = function(activities) {
            console.log('calculateStats called with:', activities);
            if (!activities || !Array.isArray(activities)) {
                console.log('No activities or not an array');
                return;
            }

            console.log('Calculating stats for', activities.length, 'activities');

            self.activeCount = 0;
            self.completedCount = 0;
            var uniqueLessons = {};
            var allKits = new Set();

            self.completedActivities = [];

            activities.forEach(function(activity) {
                if (activity.active) {
                    self.activeCount++;
                } else {
                    self.completedCount++;
                    self.completedActivities.push(activity);
                }

                if (activity.lesson && activity.lesson.lesson_id) {
                    if (!uniqueLessons[activity.lesson.lesson_id]) {
                        uniqueLessons[activity.lesson.lesson_id] = {
                            lesson: activity.lesson,
                            activities: [],
                            completedCount: 0,
                            activeCount: 0
                        };
                    }
                    uniqueLessons[activity.lesson.lesson_id].activities.push(activity);
                    if (activity.active) {
                        uniqueLessons[activity.lesson.lesson_id].activeCount++;
                    } else {
                        uniqueLessons[activity.lesson.lesson_id].completedCount++;
                    }
                }

                if (activity.device_ids && Array.isArray(activity.device_ids)) {
                    activity.device_ids.forEach(function(kit) {
                        allKits.add(kit);
                    });
                }
            });

            self.uniqueLessonsCount = Object.keys(uniqueLessons).length;
            self.totalKitsCount = allKits.size;

            self.lessonGroups = Object.values(uniqueLessons);

            console.log('Stats calculated:', {
                activeCount: self.activeCount,
                completedCount: self.completedCount,
                uniqueLessonsCount: self.uniqueLessonsCount,
                totalKitsCount: self.totalKitsCount,
                completedActivities: self.completedActivities.length,
                lessonGroups: self.lessonGroups.length
            });
        };

        self.viewActivityDashboard = function(e) {
            if (e.item && e.item.a) {
                events.emit('navigate_to_activity', {
                    act_ref: e.item.a.activity_ref,
                    view: 'dashboard'
                });
            }
        };

        self.startDuplicateActivity = function(e) {
            if (e.item && e.item.a) {
                events.emit('duplicate_activity', e.item.a);
            }
        };

        self._lastActivities = null;

        self.on('mount', function() {
            console.log('User dashboard mounted', self.opts);
            events.on('dashboard_data', function(activities) {
                console.log('Dashboard received activities via event:', activities);
                self.calculateStats(activities);
                self.update();
            });

            if (self.opts.activities) {
                console.log('Dashboard calculating from opts.activities:', self.opts.activities);
                self._lastActivities = self.opts.activities;
                self.calculateStats(self.opts.activities);
                self.update();
            }
        });

        self.on('update', function() {

            if (self.opts.activities && self.opts.activities !== self._lastActivities) {
                self._lastActivities = self.opts.activities;
                self.calculateStats(self.opts.activities);
            }
        });

        self.on('unmount', function() {
            events.off('dashboard_data');
        });

});
